export default __webpack_public_path__ + "static/media/trainingIcon.5dd1088d.svg";